import { Component, type ErrorInfo, type ReactNode } from "react";
import { Button } from "@/components/ui/button";

type Props = {
  children: ReactNode;
  fallback?: ReactNode;
};

type State = {
  hasError: boolean;
};

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(
      "Unhandled UI error caught by ErrorBoundary:",
      error,
      errorInfo,
    );
  }

  handleReload = () => {
    this.setState({ hasError: false });
    globalThis.location.reload();
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-gray-50 px-6 text-center">
          <h1 className="text-xl font-semibold text-gray-900">
            Etwas ist schiefgelaufen.
          </h1>
          <p className="max-w-md text-sm text-gray-500">
            Es ist ein unerwarteter Fehler aufgetreten. Bitte laden Sie die
            Seite neu. Falls das Problem weiterhin besteht, kontaktieren Sie
            bitte den Support.
          </p>
          <Button
            type="button"
            variant="primary"
            className="rounded-full px-4 py-2 text-xs font-semibold text-white"
            onClick={this.handleReload}
          >
            Seite neu laden
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
